import { render } from "./ModalConfirmHired.vue?vue&type=template&id=663873fc&scoped=true"
import script from "./ModalConfirmHired.vue?vue&type=script&lang=js"
export * from "./ModalConfirmHired.vue?vue&type=script&lang=js"

import "./ModalConfirmHired.vue?vue&type=style&index=0&id=663873fc&lang=scss&scoped=true"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663873fc"]])

export default __exports__